// mui components
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";

// redux
import { useSelector, useDispatch } from "react-redux";
import { loadSignificanceToggleState } from "store/features/analysisResultsSlice";

//Props Validations
import PropTypes from "prop-types";

function SignificanceToggleComponent({ disabled = false }) {
    const dispatch = useDispatch();

    const significanceToggle = useSelector((state) => state.analysisResultsStore.significanceToggle);
    const disableSignificanceToggle = useSelector((state) => state.analysisResultsStore.disableSignificanceToggle);

    const handleSignificanceToggleChange = () => {
        dispatch(loadSignificanceToggleState(!significanceToggle));
    };
    return (
        <Button
            size="small"
            className={significanceToggle && !disabled ? "custom-btn custom-btn-outlined-2 color-blue me-4 bold-content" : "custom-btn me-4 bold-content"}
            disabled={disableSignificanceToggle || disabled}
            variant="outlined"
        >
            Significance
            <Switch
                size="small"
                disabled={disableSignificanceToggle || disabled}
                checked={disabled ? false : significanceToggle}
                onChange={handleSignificanceToggleChange}
            />
        </Button>
    );
}

SignificanceToggleComponent.propTypes = {
    disabled: PropTypes.string,
};

export default SignificanceToggleComponent;
